import { createHook, createStore, StoreActionApi } from "react-sweet-state"
import { load, LoadingState, LoadingStateDefaults } from "components/state/loader"
import { LoadingStateModifiers } from "components/state/loadingstate"
import { EndpointResponse } from "components/http/endpoint"
import { StatusCode } from "components/http/ajax/statusCode"
import { Container } from "components/state/types"
import { OsobniUdaje, UserAccess } from "./entity"
import { NoEntityError, updateByResponse, errorToEntityError } from "components/validation/validatableentity"
import { apiLoadMemberData, apiGetMemberCardUrl } from "./endpoint";
import { EntityState, setEntityField, setStateField } from "components/state/entity"



interface State extends EntityState<OsobniUdaje> {
    memberCardUrl: string;
    isSecretary: boolean;
}

const StateDefaults: State = {
    ...LoadingStateDefaults,
    entity: null,
    errors: { ...NoEntityError },
    memberCardUrl: "",
    isSecretary: false,
}


const loadMemberData = (memberIdt: number) =>
    (store: StoreActionApi<State>) => {

        let loader = () => apiLoadMemberData(memberIdt);

        let stateProducer = (draft: State, _: Container, response: EndpointResponse): void => {
            if (response.status == StatusCode.NotFound) {
                const errMessage = `Člen(ka) s IDT ${memberIdt} nebyl(a) nalezen(a)`;
                errorToEntityError(draft, errMessage, true);
            } else {
                updateByResponse(draft, response);
                const entity = draft.entity;
                draft.memberCardUrl = apiGetMemberCardUrl(entity?.idtClena);
                draft.isSecretary = entity == null ? false : (entity.userAccess & UserAccess.VerifiedPerson) !== 0;
            }
        }

        load<State>(store, loader, stateProducer);
    };

const store = createStore({
    initialState: StateDefaults,
    actions: {
        loadMemberData,
    },
    name: "MemberDetail"
});

const useState = createHook(store);

export {
    StateDefaults as MemberDetailStateDefaults,
    State as MemberDetailState,
    useState as useMemberDetail,
}
